/**
 * API base URL - works in dev and clinic desktop without manual changes.
 * - VITE_API_BASE_URL: override via env
 * - Dev: /api (Vite proxy to backend)
 * - Prod/clinic: window.location.origin + '/api' (served from same origin)
 */
export const getApiBaseUrl = (): string => {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL.replace(/\/$/, '') || '/api';
  }
  if (import.meta.env.DEV) {
    return '/api';
  }
  return `${typeof window !== 'undefined' ? window.location.origin : ''}/api`;
};

/** Base URL without /api suffix (for PDF iframes, etc.) */
export const getBaseUrl = (): string => {
  return (
    getApiBaseUrl().replace(/\/api\/?$/, '') ||
    (typeof window !== 'undefined' ? window.location.origin : '')
  );
};
